import { gql } from '@apollo/client';

// Existing 1:1 thread between the viewer and userId (id only), or null.
// Lets "Message" buttons open the existing conversation instead of a new compose.
export const DIRECT_THREAD_WITH_QUERY = gql`
  query DirectThreadWith($userId: ID!) {
    directThreadWith(userId: $userId) {
      id
    }
  }
`;

// AI context-aware one-tap quick replies for a thread. Empty ⇒ client uses the curated set.
export const DM_SUGGESTED_REPLIES_QUERY = gql`
  query DmSuggestedReplies($messageId: ID!, $partId: ID) {
    dmSuggestedReplies(messageId: $messageId, partId: $partId)
  }
`;

export const CREATE_DIRECT_MESSAGE_MUTATION = gql`
  mutation CreateDirectMessage($input: CreateDirectMessageInput!) {
    createDirectMessage(input: $input) {
      success
      created
      error
      message {
        id
        threadType
        createdById
        subject
        updatedAt
      }
    }
  }
`;

export const ADD_MESSAGE_PARTICIPANTS_MUTATION = gql`
  mutation AddMessageParticipants($messageId: ID!, $userIds: [ID!]!) {
    addMessageParticipants(messageId: $messageId, userIds: $userIds) {
      id
      threadType
      participants {
        id
        userId
        user {
          asfId
          firstName
          lastName
        }
      }
    }
  }
`;

export const LEAVE_MESSAGE_MUTATION = gql`
  mutation LeaveMessage($messageId: ID!) {
    leaveMessage(messageId: $messageId)
  }
`;

export const MUTE_MESSAGE_MUTATION = gql`
  mutation MuteMessage($messageId: ID!, $muted: Boolean!) {
    muteMessage(messageId: $messageId, muted: $muted)
  }
`;

export const SEND_MESSAGE_PART_MUTATION = gql`
  mutation SendMessagePart($input: SendMessagePartInput!) {
    sendMessagePart(input: $input) {
      success
      error
      messagePart {
        id
        messageId
        content
        createdAt
        senderUserId
        status
        attachments {
          id
          position
          image {
            id
            optimizedUrl
            thumbnailUrl
          }
          file {
            url
            name
            mediaType
            size
          }
        }
        sender {
          kind
          userId
          contactId
          user {
            asfId
            firstName
            lastName
          }
          contact {
            id
            name
          }
        }
      }
    }
  }
`;

export const TRANSLATE_MESSAGE_PART = gql`
  mutation TranslateMessagePart($messagePartId: ID!, $locale: String!) {
    translateMessagePart(messagePartId: $messagePartId, locale: $locale) {
      locale
      content
      status
    }
  }
`;

export const MARK_MESSAGE_READ_MUTATION = gql`
  mutation MarkMessageRead($messageId: ID!) {
    markMessageRead(messageId: $messageId)
  }
`;
